/* eslint-env jquery */
const $ = jQuery.noConflict();

let prevInfoWindow = false;


'use strict';
const StoreMap = {

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		if ($('.js-map').length < 1) {
			return;
		}
		StoreMap.initMap($('.acf-map'));
	},

	initMap: (element) => {
		// Find marker elements within map.
		const markers = element.find('.marker');
		const country = 'America';
		// Create generic map.
		const mapArgs = StoreMap.getMapArgs(element);

		// eslint-disable-next-line no-undef
		const map = new google.maps.Map(element[0], mapArgs);
		// eslint-disable-next-line no-undef
		const geocoder = new google.maps.Geocoder();

		geocoder.geocode({'address': country}, function(results, status) {
			// eslint-disable-next-line no-undef
			if (status === google.maps.GeocoderStatus.OK) {
				map.setCenter(results[0].geometry.location);
				map.fitBounds(results[0].geometry.viewport);
				map.setZoom(4);
			}
		});

		// Add markers.
		map.markers = [];
		markers.each(function() {
			StoreMap.initMarker($(this), map);
			StoreMap.addMarkerFromJson($(this), map);
		});

		// Center map based on markers.
		StoreMap.centerMap(map);

		// Return map instance.
		StoreMap.map = map;
		return map;
	},

	getMapArgs: (element) => {
		return {
			zoom: element.data('zoom') || 16,
			// eslint-disable-next-line no-undef
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true, //disables controls
			styles: [
				{
					'featureType': 'administrative',
					'elementType': 'labels.text.fill',
					'stylers': [
						{
							'color': '#444444'
						}
					]
				},
				{
					'featureType': 'landscape',
					'elementType': 'all',
					'stylers': [
						{
							'color': '#f2f2f2'
						}
					]
				},
				{
					'featureType': 'poi',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'off'
						}
					]
				},
				{
					'featureType': 'road',
					'elementType': 'all',
					'stylers': [
						{
							'saturation': -100
						},
						{
							'lightness': 45
						}
					]
				},
				{
					'featureType': 'road.highway',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'simplified'
						}
					]
				},
				{
					'featureType': 'road.arterial',
					'elementType': 'labels.icon',
					'stylers': [
						{
							'visibility': 'off'
						}
					]
				},
				{
					'featureType': 'transit',
					'elementType': 'all',
					'stylers': [
						{
							'visibility': 'off'
						}
					]
				},
				{
					'featureType': 'water',
					'elementType': 'all',
					'stylers': [
						{
							'color': '#46bcec'
						},
						{
							'visibility': 'on'
						}
					]
				},
				{
					'featureType': 'water',
					'elementType': 'geometry.fill',
					'stylers': [
						{
							'color': '#8fbfe6'
						}
					]
				}
			]
		};
	},

	initMarker: (location, map) => {
		// Get position from marker.
		const lat = location.data('lat');
		const lng = location.data('lng');
		const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
		// eslint-disable-next-line no-undef
		const marker = new google.maps.Marker({
			position: {
				lat: parseFloat(lat),
				lng: parseFloat(lng),
			},
			map: map,
			icon: image,
			// eslint-disable-next-line no-undef
			animation: google.maps.Animation.BOUNCE
		});

		// Append to reference for later use.
		map.markers.push(marker);

		// If marker contains HTML, add it to an infoWindow.
		if (location.html()) {
			// Create info window.
			// eslint-disable-next-line no-undef
			const infoWindow = new google.maps.InfoWindow({
				content: location.html()
			});
			// Show info window when marker is clicked.
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(marker, 'click', function() {
				infoWindow.open(map, marker);
			});
		}
	},

	addMarkerFromJson: (pin, map) => {
		// eslint-disable-next-line no-undef
		const position = new google.maps.LatLng(pin.lat, pin.lng);
		let icon= '';
		if (pin.category[0].slug === 'truck-wash-locations') {
			// eslint-disable-next-line no-undef,camelcase
			icon = window.fwsLocalized.themeRoot + '/src/assets/images/OK_Map_Marker-1.png';
		}
		if (pin.category[0].slug === 'trucking-companies') {
			// eslint-disable-next-line no-undef,camelcase
			icon = window.fwsLocalized.themeRoot + '/src/assets/images/OK_Map_Marker-2.png';
		}
		// eslint-disable-next-line no-undef
		const marker = new google.maps.Marker({
			position: position,
			map: map,
			// eslint-disable-next-line no-undef,camelcase
			icon: icon
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if (pin.html) {
			// create info window
			// eslint-disable-next-line no-undef
			const infowindow = new google.maps.InfoWindow({
				content: pin.html
			});
			// show info window when marker is clicked
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(marker, 'click', function() {
				if(prevInfoWindow) {
					prevInfoWindow.close();
				}
				prevInfoWindow = infowindow;
				infowindow.open(map, marker);
			});
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(map, 'click', function() {
				infowindow.close();
			});
		}
		if (pin.str) {
			// create info window
			// eslint-disable-next-line no-undef
			const infoWindow = new google.maps.InfoWindow;

			infoWindow.setContent(pin.str);
			infoWindow.open(map, marker);
		}
	},

	centerMap: (map) => {
		// Create map boundaries from all map markers.
		// eslint-disable-next-line no-undef
		const bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function(marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});
		// Case: Single marker.
		// eslint-disable-next-line eqeqeq
		if (map.markers.length === 1) {
			map.setCenter(bounds.getCenter());
			// Case: Multiple markers.
		} else {
			map.fitBounds(bounds);
		}
	},

	addMarkersFromResponse: (value) => {
		// eslint-disable-next-line no-unused-vars
		$.each(StoreMap.map.markers, (i, marker) => {
			StoreMap.map.markers[i].setMap(null);
		});

		// add markers
		$.each(value, (key, value) => {
			StoreMap.addMarkerFromJson(value, StoreMap.map);
		});
		StoreMap.centerMap(StoreMap.map);
	},
};

export default StoreMap;
